module.exports = __webpack_public_path__ + "media/images/pc/specials/common/plan_yoso_location-0d12661244552ff2979257464908b5bb.jpg";